<template lang="pug">
    div
        b-btn.m-3(v-b-modal="'search_high_school' + multi_field_num" size="sm")
            | Search for a High School
        q_text(
        question="Name"
        slug="q_high_school_name"
        :multi_field_num="multi_field_num"
        )
        q_searchable_ddl(
        question="Country"
        slug="q_high_school_country"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="City"
        slug="q_high_school_city"
        :multi_field_num="multi_field_num"
        )
        q_dynamic_ddl(
        question="State"
        slug="q_high_school_state"
        :multi_field_num="multi_field_num"
        )
        q_dynamic_ddl(
        question="Province"
        slug="q_high_school_province"
        :multi_field_num="multi_field_num"
        )
        q_text(
        question="CEEB Code"
        slug="q_high_school_ceeb"
        :multi_field_num="multi_field_num"
        )
        q_date(
        question="Start Date"
        slug="q_high_school_start"
        :multi_field_num="multi_field_num"
        placeholder='mm/yyyy'
        )
        q_date(
        question="End Date"
        slug="q_high_school_end"
        :multi_field_num="multi_field_num"
        placeholder='mm/yyyy'
        )
        q_date(
        question="Graduation Date"
        slug="q_high_school_grad_date"
        :multi_field_num="multi_field_num"
        placeholder='mm/yyyy'
        )
        div
            HighSchoolSearch(v-bind:multi_field_num="multi_field_num")
</template>
<script>
import MultiField from "../../baseQuestion/multiField";
import q_text from "../../baseQuestion/text";
import q_dynamic_ddl from "../../baseQuestion/dynamicDDL";
import q_searchable_ddl from "../../baseQuestion/searchableDDL";
import HighSchoolSearch from "../../highSchoolSearch";
import q_date from "../../baseQuestion/date";

export default {
	extends: MultiField,
	props: ["multi_field_num"],
	components: {
		q_text,
		q_dynamic_ddl,
		q_searchable_ddl,
		HighSchoolSearch,
		q_date
	},
	methods: {
		process_delete() {
			this.$emit("trigger-delete", this.multi_field_num);
		}
	}
};
</script>
